"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyRule = void 0;
var global_1 = require("./global");
/** 政策規則 */
var PolicyRule = /** @class */ (function () {
    /**
     * 建構策略規則
     * @param permission 權限，預設為不須權限
     */
    function PolicyRule(permission) {
        if (permission === void 0) { permission = ''; }
        this.subExpressions = [];
        this.expression = typeof permission === 'string' ? permission : permission.join('\t&\t');
    }
    PolicyRule.prototype.and = function (permissionOrRule) {
        if (typeof permissionOrRule === 'string') {
            var permission = permissionOrRule;
            this.expression += this.expression === '' ? permission : "\t&\t" + permission;
        }
        else {
            var rule = permissionOrRule;
            this.subExpressions.push({ oprtator: global_1.LogicalConnective.And, rule: rule });
        }
        return this;
    };
    PolicyRule.prototype.or = function (permissionOrRule) {
        if (typeof permissionOrRule === 'string') {
            var permission = permissionOrRule;
            this.expression += this.expression === '' ? permission : "\t|\t" + permission;
        }
        else {
            var rule = permissionOrRule;
            this.subExpressions.push({ oprtator: global_1.LogicalConnective.Or, rule: rule });
        }
        return this;
    };
    PolicyRule.prototype.checkExpression = function (permissions) {
        if (this.expression === '')
            return true;
        var expressionTree = this.expression.split('\t|\t').map(function (e) { return e.split('\t&\t'); });
        for (var _i = 0, expressionTree_1 = expressionTree; _i < expressionTree_1.length; _i++) {
            var orExpression = expressionTree_1[_i];
            var orResult = orExpression.reduce(function (result, permission) {
                return result && permissions.includes(permission);
            }, true);
            if (orResult)
                return true;
        }
        return false;
    };
    /**
     * 檢查指定的權限是否符合此規則
     * @param permissions 權限
     */
    PolicyRule.prototype.check = function (permissions) {
        if (permissions.length == 1 && permissions[0] === 'Administrator')
            return true;
        var result = this.checkExpression(permissions);
        this.subExpressions.forEach(function (expression) {
            switch (expression.oprtator) {
                case global_1.LogicalConnective.Or:
                    result || (result = expression.rule.check(permissions));
                    break;
                default:
                    result && (result = expression.rule.check(permissions));
                    break;
            }
        });
        return result;
    };
    return PolicyRule;
}());
exports.PolicyRule = PolicyRule;
/** 政策 */
var Policy = /** @class */ (function () {
    /**
     * 建構政策
     * @param options 選項
     */
    function Policy(model, options) {
        var _this = this;
        var _a;
        /** 全域規則 */
        this.globalRules = {};
        this.model = model;
        if (!options)
            return;
        this.router = options.router;
        this.sitemap = options.sitemap;
        this.loginRoute = options.loginRoute;
        this.globalRules = options.globalRules || {};
        this.guard = options.guard;
        (_a = this.router) === null || _a === void 0 ? void 0 : _a.beforeEach(function (to, from, next) { return __awaiter(_this, void 0, void 0, function () {
            var rule, approved, user, error_1;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        rule = (_a = to.meta) === null || _a === void 0 ? void 0 : _a.rule;
                        approved = true;
                        if (!(from.path === '/' || (rule && rule !== ((_b = from.meta) === null || _b === void 0 ? void 0 : _b.rule)))) return [3 /*break*/, 5];
                        user = model.guest;
                        if (!model.user.Token) return [3 /*break*/, 4];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.model.reloadUser()];
                    case 2:
                        user = _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _c.sent();
                        console.log('Policy ACL check error: ', error_1);
                        return [3 /*break*/, 4];
                    case 4:
                        if (rule instanceof PolicyRule)
                            approved = this.isApproved(user, rule);
                        else if (typeof rule === 'string')
                            approved = this.isApproved(user, rule);
                        else if (Array.isArray(rule))
                            approved = this.isApproved(user, rule);
                        _c.label = 5;
                    case 5:
                        if (approved) {
                            this.model.menu = this.makeMenu();
                            if (this.guard)
                                this.guard(to, from, next);
                            else
                                next();
                        }
                        else if (options.loginRoute) {
                            next(options.loginRoute);
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    }
    /**
     * 已指定用戶進行登入
     * @param user 用戶
     * @param rememberable 是否記住(持續登入)
     */
    Policy.prototype.login = function (user, rememberable) {
        this.model.commit('user', user);
        CloudFun.item(this.model.name + "-user", JSON.stringify(user), !rememberable);
    };
    /**
     * 登出
     */
    Policy.prototype.logout = function () {
        this.model.commit('user', null);
        CloudFun.item(this.model.name + "-user", null);
    };
    Policy.prototype.isApproved = function (user, permissionsOrRule) {
        var rule = permissionsOrRule instanceof PolicyRule ? permissionsOrRule :
            typeof permissionsOrRule === 'string' ? this.globalRules[permissionsOrRule] || new PolicyRule(permissionsOrRule) :
                new PolicyRule(permissionsOrRule);
        return rule.check(user.Permissions);
    };
    Policy.prototype.findActiveMenu = function (subNodes, prefix) {
        var _this = this;
        if (prefix === void 0) { prefix = ''; }
        if (!this.router)
            return false;
        var match = false;
        var route = this.router.currentRoute.value;
        subNodes.forEach(function (node) {
            if (typeof node !== 'string' && node.to) {
                var path = node.to.startsWith('/') ? node.to : node.to === '' ? prefix : prefix + "/" + node.to;
                if (path === '')
                    path = '/';
                if (!node.ignore && path === route.path)
                    match = true;
                else if (!match && node.subNodes)
                    match = _this.findActiveMenu(node.subNodes, prefix);
            }
        });
        return match;
    };
    Policy.prototype.makeMenu = function (prefixOrNodes, prefix, crumbable) {
        var _this = this;
        if (prefix === void 0) { prefix = ''; }
        if (crumbable === void 0) { crumbable = true; }
        if (!this.sitemap)
            return [];
        if (!this.router)
            return this.sitemap.subNodes || [];
        var router = this.router;
        var route = router.currentRoute.value;
        var result = [];
        var nodes = prefixOrNodes !== undefined && typeof prefixOrNodes !== 'string' ? prefixOrNodes : this.sitemap.subNodes || [];
        if (typeof prefixOrNodes === 'string')
            prefix = prefixOrNodes;
        var user = this.model.user;
        var breadcrumb = this.model.breadcrumb;
        if (prefixOrNodes === undefined || typeof prefixOrNodes === 'string') { // Make home node
            var menuNode = __assign({ active: true, activeDropdown: true }, this.sitemap);
            if (menuNode.to !== undefined) {
                if (!menuNode.to.startsWith('/'))
                    menuNode.to = menuNode.to === '' ? prefix : prefix + "/" + menuNode.to;
                if (menuNode.to === '')
                    menuNode.to = '/';
            }
            if (crumbable) {
                breadcrumb.length = 0;
                breadcrumb.push(menuNode);
            }
        }
        // Make sub nodes
        nodes.forEach(function (node) {
            if (typeof node === 'string')
                result.push(node);
            else {
                var menuNode = __assign({}, node);
                if (menuNode.to !== undefined) {
                    if (!menuNode.to.startsWith('/'))
                        menuNode.to = menuNode.to === '' ? prefix : prefix + "/" + menuNode.to;
                    if (menuNode.to === '')
                        menuNode.to = '/';
                    menuNode.active = !menuNode.ignore && (menuNode.to === route.path || (menuNode.subNodes && _this.findActiveMenu(menuNode.subNodes, prefix)));
                    if (crumbable && menuNode.active)
                        breadcrumb.push(menuNode);
                    if (menuNode.subNodes) {
                        menuNode.activeDropdown = _this.findActiveMenu(menuNode.subNodes, prefix);
                        menuNode.subNodes = _this.makeMenu(menuNode.subNodes, prefix, crumbable);
                    }
                }
                if (menuNode.to) {
                    var location_1 = router.resolve(menuNode.to);
                    var rule = location_1.meta.rule;
                    if (!rule) {
                        result.push(menuNode);
                    }
                    else {
                        if (typeof rule === 'string' && _this.isApproved(user, rule))
                            result.push(menuNode);
                        else if (rule instanceof PolicyRule && _this.isApproved(user, rule))
                            result.push(menuNode);
                        else if (Array.isArray(rule) && !rule.some(function (e) { return typeof e !== 'string'; }) && _this.isApproved(user, rule))
                            result.push(menuNode);
                    }
                }
                else
                    result.push(menuNode);
            }
        });
        return result;
    };
    return Policy;
}());
exports.default = Policy;
